// src/portals/fan/pages/SettingsPage/SettingsPage.js
import React from "react";
import PageHeader from "../../components/PageHeader";
import SettingsToggle from "./components/SettingsToggle";

const SettingsPage = () => {
  return (
    <div className="flex flex-col h-full bg-slate-50">
      <PageHeader title="Settings" backTo="/fan/profile" />
      <div className="flex-grow overflow-y-auto">
        <div className="pt-4">
          <h2 className="px-4 pb-2 text-sm font-semibold text-slate-500">
            NOTIFICATIONS
          </h2>
          <div className="bg-white border-y border-slate-200 divide-y divide-slate-100">
            <SettingsToggle
              label="SMS Notifications"
              description="Get important updates sent to your Phone Number."
              initialValue={false}
            />
            <SettingsToggle
              label="Push Notifications"
              description="Receive updates on new content and messages."
              initialValue={true}
            />
            <SettingsToggle
              label="Email Notifications"
              description="Get important updates sent to your email."
              initialValue={false}
            />
          </div>
        </div>
        <div className="pt-6">
          <h2 className="px-4 pb-2 text-sm font-semibold text-slate-500">
            PRIVACY
          </h2>
          <div className="bg-white border-y border-slate-200 divide-y divide-slate-100">
            <SettingsToggle
              label="Public Fan Profile"
              description="Allow other fans to see your profile."
              initialValue={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
